import PropTypes from 'prop-types';

export const GdprConsentType = PropTypes.shape({
    name: PropTypes.string,
    code: PropTypes.string,
    id: PropTypes.string,
    isRequired: PropTypes.bool,
    isAgreed: PropTypes.bool,
    text: PropTypes.string,
    link_type: PropTypes.number,
    cms_page_identifier: PropTypes.string
});

export const GdprInformationsType = PropTypes.shape({
    consents: PropTypes.shape({
        registration: PropTypes.arrayOf(GdprConsentType),
        checkout: PropTypes.arrayOf(GdprConsentType),
        contactus: PropTypes.arrayOf(GdprConsentType),
        subscription: PropTypes.arrayOf(GdprConsentType)
    }),
    isPopupEnabled: PropTypes.bool,
    privacyPolicy: PropTypes.string
});
